<template>
  <div class="carousel-container" style="height: 85vh">
    <div ref="carouselRef" id="carouselExampleCaptions" class="carousel slide h-100" data-ride="carousel">
      <ol class="carousel-indicators">
        <li v-for="(item, index) in carouselItems" :key="index" 
            :data-target="'#carouselExampleCaptions'"
            :data-slide-to="index" 
            :class="{ active: index === currentSlide }" 
            @click="handleIndicatorClick(index)"></li>
      </ol>

      <div class="carousel-inner h-100">
        <div v-for="(item, index) in carouselItems" :key="index" 
             class="carousel-item h-100"
             :class="{ active: index === currentSlide }">
          <!-- 图片轮播项 -->
          <img v-if="item.imageUrl" 
               :src="item.imageUrl" 
               class="d-block w-100 h-100 object-cover" 
               :alt="item.title || '轮播图片'"
               loading="lazy" /> 

          <!-- 视频轮播项：ref 绑定为数组（动态索引），优化播放逻辑 -->
          <div class="video-item w-100 h-100" v-if="item.videoUrl">
            <video ref="carouselVideo"  
                   class="w-100 h-100 object-cover" 
                   :src="item.videoUrl" 
                   muted 
                   playsinline
                   style="background-color: black;"
                   @play="onVideoPlay(index)" 
                   @ended="onVideoEnd(index)">
            </video>
          </div>

          <!-- 轮播文案 -->
          <div class="carousel-caption bg-opacity-50 rounded p-4" v-if="item.title">
            <h2 style="color: white">{{ item.title }}</h2>
            <p>{{ item.description }}</p>
            <button type="button" class="btn btn-outline-light" @click="routerFun(item.toType)">
              查看更多
            </button>
          </div>
        </div>
      </div>

      <!-- 左右切换按钮 -->
      <button class="carousel-control-prev" type="button" 
              data-target="#carouselExampleCaptions" 
              data-slide="prev"
              @click="handlePrevSlide">
        <i class="bi bi-chevron-left" style="font-size: 2em; font-weight: bold"></i>
      </button>
      <button class="carousel-control-next" type="button" 
              data-target="#carouselExampleCaptions" 
              data-slide="next"
              @click="handleNextSlide">
        <i class="bi bi-chevron-right" style="font-size: 2em; font-weight: bold"></i>
      </button>

    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "CarouselComponent",
  data() {
    return {
      currentSlide: 0,
      isVideoPlaying: false, // 标记当前是否有视频在播放
      lastVideoIndex: -1, // 记录上一个播放视频的索引，用于切换时暂停
      carouselItems: [
        { videoUrl: "https://hqhotel5.obs.cn-macau-221.ctmcloud.com.mo/Public/20260129_1.mp4", title: '', toType: '', description: "" },
        { videoUrl: "https://hqhotel5.obs.cn-macau-221.ctmcloud.com.mo/Public/20260129_3.mp4", title: '', toType: '', description: "" },
        { videoUrl: "https://hqhotel5.obs.cn-macau-221.ctmcloud.com.mo/Public/20260129_2.mp4", title: '', toType: '', description: "" },
        { videoUrl: "https://www.hqhotel5.com/media/artspace.mp4", title: '', toType: '', description: "" },
        { imageUrl: "https://www.hqhotel5.com/img/MiniImg/ht01.jpg", title: "", toType: "", description: "" },
        { imageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/1.jpg", title: "", toType: "", description: "" },
        { imageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/2.jpg", title: "", toType: "", description: "" },
        { imageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/3.png", title: "", toType: "", description: "" },
        { imageUrl: "https://www.hqhotel5.com/img/hotelImgs/yxbigbed/8.png", title: "艺术空间", toType: "/artspace", description: "" },
        // { imageUrl: "https://www.hqhotel5.com/img/hotelImgs/bigbed/1.jpg", title: "酒店客房", toType: "/room", description: "" },
      ],
      carouselInterval: null,
      startPlayTimer: null,
    };
  },
  mounted() {
    this.initCarousel();
    this.bindCarouselChangeEvent();
    // 初始化时，如果第一个是视频，自动播放
    this.initFirstVideo();
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
    this.clearAllTimers();
    this.pauseAllVideos(); // 销毁前暂停所有视频，释放资源
    $(this.$refs.carouselRef).carousel("dispose");
  },
  methods: {
    initCarousel() {
      $(this.$refs.carouselRef).carousel({
        pause: "hover",
        interval: false, // 关闭bootstrap自带自动轮播，用自定义定时器
      });
    },

    bindCarouselChangeEvent() {
      $(this.$refs.carouselRef).on('slid.bs.carousel', (e) => {
        const newSlideIndex = $(e.relatedTarget).index();
        // 1. 切换前，暂停上一个视频（如果有）
        this.pauseLastVideo();
        // 2. 更新当前轮播索引
        this.currentSlide = newSlideIndex;
        // 3. 切换后，处理当前项（视频自动播放，非视频恢复轮播）
        const currentItem = this.carouselItems[this.currentSlide];
        if (currentItem?.videoUrl) {
          this.stopAutoPlay();
          this.playCurrentVideo(); // 手动触发当前视频播放，比autoplay更可靠
        } else {
          this.isVideoPlaying = false;
          this.startAutoPlay();
        }
      });
    },

    // 初始化第一个视频（如果第一个是视频）
    initFirstVideo() {
      const firstItem = this.carouselItems[0];
      if (firstItem?.videoUrl) {
        this.playVideoByIndex(0);
      }
    },

    // 播放当前轮播的视频
    playCurrentVideo() {
      this.playVideoByIndex(this.currentSlide);
    },

    // 根据索引播放指定视频
    playVideoByIndex(index) {
      const videoElements = this.$refs.carouselVideo;
      if (!videoElements || !videoElements[index]) return;

      const videoDom = videoElements[index];
      videoDom.currentTime = 0; // 重置视频到开头（避免切换回来继续播放）
      videoDom.play().catch(err => {
        console.error(`视频 ${index} 播放失败：`, err);
      });
      this.lastVideoIndex = index; // 记录当前播放视频的索引
    },

    // 暂停上一个播放的视频
    pauseLastVideo() {
      if (this.lastVideoIndex === -1) return;
      const videoElements = this.$refs.carouselVideo;
      if (!videoElements || !videoElements[this.lastVideoIndex]) return;

      videoElements[this.lastVideoIndex].pause();
      // 可选：重置上一个视频到开头
      videoElements[this.lastVideoIndex].currentTime = 0;
    },

    // 暂停所有视频（销毁组件时用）
    pauseAllVideos() {
      const videoElements = this.$refs.carouselVideo;
      if (!videoElements) return;

      // 兼容单个视频（非数组）和多个视频（数组）
      const videos = Array.isArray(videoElements) ? videoElements : [videoElements];
      videos.forEach(video => video && video.pause());
      this.lastVideoIndex = -1;
      this.isVideoPlaying = false;
    },

    // 清除所有定时器
    clearAllTimers() {
      this.startPlayTimer && clearTimeout(this.startPlayTimer);
      this.carouselInterval && clearInterval(this.carouselInterval);
      this.startPlayTimer = null;
      this.carouselInterval = null;
    },

    startAutoPlay() {
      this.stopAutoPlay(); // 先清除旧定时器，避免叠加
      // 只有非视频播放状态才启动自动轮播
      if (!this.isVideoPlaying) {
        this.carouselInterval = setInterval(() => {
          $(this.$refs.carouselRef).carousel("next");
        }, 6500); // 6.5秒切换一次，可调整
      }
    },

    stopAutoPlay() {
      this.clearAllTimers();
    },

    // 视频开始播放时，标记状态并暂停自动轮播
    onVideoPlay(index) {
      this.isVideoPlaying = true;
      this.lastVideoIndex = index;
      this.stopAutoPlay();
    },

    // 视频播放完毕后，自动切下一张并恢复轮播
    onVideoEnd(index) {
      // 仅处理当前正在播放的视频（避免切换后旧视频触发结束事件）
      if (index !== this.currentSlide) return;

      this.isVideoPlaying = false;
      this.lastVideoIndex = -1;
      // 自动切换到下一张
      $(this.$refs.carouselRef).carousel("next");
      // 恢复自动轮播（延迟一点，避免切换动画和定时器冲突）
      setTimeout(() => {
        this.startAutoPlay();
      }, 500);
    },

    resetAutoPlay() {
      this.clearAllTimers();
      // 延迟重置自动轮播，避免用户快速点击时定时器叠加
      this.startPlayTimer = setTimeout(() => {
        this.isVideoPlaying = false; // 用户手动切换，强制取消视频播放状态
        this.pauseLastVideo(); // 手动切换时，暂停当前视频
        this.startAutoPlay();
      }, 1000); // 1秒延迟，体验更流畅
    },

    handlePrevSlide() {
      $(this.$refs.carouselRef).carousel("prev");
      this.resetAutoPlay();
    },

    handleNextSlide() {
      $(this.$refs.carouselRef).carousel("next");
      this.resetAutoPlay();
    },

    handleIndicatorClick(index) {
      $(this.$refs.carouselRef).carousel(index);
      this.resetAutoPlay();
    },

    routerFun(routerType) {
      routerType && this.$router.push(routerType);
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-item {
  transition: transform 0.6s ease-in-out; // 优化过渡效果，更流畅
  will-change: transform;
  backface-visibility: hidden; // 解决过渡时的闪烁问题
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.carousel-inner {
  position: relative;
  overflow: hidden;
  width: 100%;
  cursor: pointer;
}

.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0; // 初始透明
  z-index: 0;
}

// 激活项样式优化
.carousel-item.active {
  position: relative;
  opacity: 1;
  z-index: 1;
}

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right,
.carousel-item.active {
  transform: translateX(0);
}

.carousel-item-next,
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev,
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-container {
  position: relative;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
  user-select: none; // 禁止选中文字，提升体验
}

.video-item {
  position: relative;
  background-color: black;
}

// 视频加载时的占位样式（可选）
video {
  object-fit: cover;
  transition: opacity 0.3s ease;
  opacity: 1;
}

video:not(:playing) {
  opacity: 0.95; // 未播放时略暗，有视觉反馈
}

.carousel-item img {
  object-fit: cover;
  transition: opacity 0.3s ease;
}

.carousel-caption {
  transform: translateY(-50%);
  bottom: initial;
  top: 50%;
  background-color: rgba(0, 0, 0, 0.3); // 优化遮罩，更清晰
  font-weight: bold;
  backdrop-filter: blur(5px); // 毛玻璃效果，提升美观度
  border: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 576px) {
    padding: 0.8rem;
    width: 90%;
    margin: 0 auto;

    h2 {
      font-size: 1.1rem;
    }

    p {
      font-size: 0.8rem;
      margin: 0.5rem 0;
    }

    button {
      padding: 0.3rem 0.8rem;
      font-size: 0.8rem;
    }
  }

  @media (max-width: 600px) {
    transform: translateY(-20%);
    top: 80%;
  }
}

.carousel-control-prev,
.carousel-control-next {
  height: 80px; // 移动端适配，略缩小按钮
  width: 40px;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(133, 133, 133, 0.5); // 降低透明度，不遮挡内容
  border-radius: 0 5px 5px 0;
  border: none;
  outline: none;
  transition: all 0.3s ease; // 过渡效果，更顺滑

  &:hover {
    background-color: rgba(255, 255, 255, 0.7);
    width: 50px; //  hover时略宽，有交互反馈

    i {
      color: black;
      transform: scale(1.1); // 图标略放大
    }
  }
}

.carousel-control-next {
  border-radius: 5px 0 0 5px;
}

// 图标样式优化
.carousel-control-prev i,
.carousel-control-next i {
  color: #fff;
  transition: all 0.3s ease;
}

.carousel-indicators {
  margin-bottom: 1.5rem; // 调整指示器位置，不遮挡内容
  bottom: 0;
}

.carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 4px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease; // 过渡效果
  opacity: 1;

  &:hover {
    background-color: rgba(255, 255, 255, 0.7);
    transform: scale(1.2); //  hover时放大
  }
}

.carousel-indicators .active {
  background-color: #fff;
  transform: scale(1.2); // 激活项放大，更醒目
}

// 解决移动端触摸滑动冲突（可选）
@media (max-width: 768px) {
  .carousel-container {
    touch-action: pan-y;
  }
}
</style>